import AreaCode from "./AreaCode.vue";
import BizRelation from './BizRelation.vue'
import ByDictSelect from './ByDictSelect.vue'
import DataCascader from './DataCascader.vue'
import DateDays from './DateDays.vue'
import DescText from './DescText.vue'
import Duration from './Duration.vue'
import Feedback from './Feedback.vue'
import InputMap from './InputMap.vue'
import OrgTreeSelect from './OrgTreeSelect.vue'
import OrgUserPicker from './OrgUserPicker.vue'
import ProvinceCity from './ProvinceCity.vue'
import SelectV2 from './SelectV2.vue'
import SignPad from './SignPad.vue'
import TableList from './TableList.vue'
import TreeRelation from './TreeRelation.vue'
import Tinymce from './Tinymce.vue'
import InputComputed from './InputComputed.vue'
import Card from "./Card.vue"
import Tabs from "./Tabs.vue"
import Collapse from "./Collapse.vue"
import GroupTitle from "./GroupTitle.vue"
import EncryptInput from "./EncryptInput.vue";
export default {
    AreaCode,
    BizRelation,
    ByDictSelect,
    DataCascader,
    DateDays,
    DescText,
    Duration,
    Feedback,
    InputMap,
    OrgTreeSelect,
    OrgUserPicker,
    ProvinceCity,
    SelectV2,
    SignPad,
    TableList,
    TreeRelation,
    Tinymce,
    InputComputed,
    Card,
    Tabs,
    Collapse,
    GroupTitle,
    EncryptInput
}